import { CardComponentProps } from "../../types/types";
import { SaleTagFilled } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/SaleTagFilled";
import { isDiorBrand } from "@JohnLewisPartnership/jl-design-system/dist/utils/brands/brands";
import classNames from "classnames/bind";
import styles from "./PromoMessages.module.scss";
import { useRef, useState } from "react";
import { QuickViewModal } from "@~/product-card-components/__shared__/QuickViewModal/QuickViewModal";
import { PromoModal } from "./PromoModal";
import { isOutletProduct } from "@~/utils/product";
import { useWindowSize } from "../../utils/hooks/useWindowSize";
import { dispatchAnalyticsEvent } from "@~/utils/analytics";
import { GLOBAL_INTERACTION } from "@~/utils/events";
import { transformVariantPriceRange } from "../Price/utils";
import { sendMonetateEvent } from "@~/utils/sendMonetateEvent";

const cx = classNames.bind(styles);

export function PromoMessages({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) {
  const { width: windowWidth } = useWindowSize();
  const isSmallScreen = windowWidth ? windowWidth < 768 : false;
  const ref = useRef(null);

  const [showModal, setShowModal] = useState(false);

  const promoMessages =
    product.messaging
      ?.filter((m) => m.type === "promotional")
      .map((m) => m.title) || [];

  if (promoMessages.length === 0) {
    return null;
  }

  const isDior = isDiorBrand(product.brand?.name || "");
  const shouldShowModal = !configProps?.hideModal && !isOutletProduct(product);
  const ModalToUse = isSmallScreen ? PromoModal : QuickViewModal;

  const renderOffers = () => {
    return (
      <>
        <button
          ref={ref}
          className={cx("offersButton", { dior: isDior })}
          onClick={() => {
            setShowModal(true);
            sendMonetateEvent("productCard.viewMoreOffers.interaction");
            dispatchAnalyticsEvent(GLOBAL_INTERACTION, {
              type: "plp",
              subType: "promotions modal",
              additionalInfo: {},
              properties: {
                promotions: promoMessages,
              },
              products: [
                {
                  brand: product.brand?.name,
                  sku: product.variants?.[0]?.aliases?.skuId || null,
                  price: product.variantPriceRange
                    ? transformVariantPriceRange(product.variantPriceRange)
                    : undefined,
                  productName: product.title,
                  productId: product.aliases.pimProductId,
                },
              ],
            });
          }}
        >
          <SaleTagFilled />
          <span className={styles.viewOffers}>
            View offers
            {product.title && (
              <span className={styles.visuallyHidden}>
                {" "}
                for {product.title}{" "}
              </span>
            )}
          </span>
        </button>
        <ModalToUse
          product={product}
          showModal={showModal}
          onClose={() => setShowModal(false)}
          originator={"VIEW_OFFERS"}
        ></ModalToUse>
      </>
    );
  };

  const renderPromoMessage = (message: string) => {
    return (
      <p
        className={cx("message", {
          dior: isDior,
        })}
        key={message}
      >
        {message}
      </p>
    );
  };

  return (
    <div data-testid="promo-messages" data-component="PromoMessages">
      {shouldShowModal && renderPromoMessage(promoMessages[0] || "")}
      {shouldShowModal && promoMessages.length > 1 && renderOffers()}
      {!shouldShowModal &&
        promoMessages.map((message) => renderPromoMessage(message))}
    </div>
  );
}
